<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="ORIM-Chapter-Title-Page-Break--Body-" id="_idParaDest-2"><a id="_idTextAnchor001"></a>Dedication</p>
<p class="ORIM-Body-Text-No-Indent-SpB4--Body-"><span class="CharOverride-2">To my fellow miners. After working 42 years in mining and metals processing all over the US, in Canada, South American, and Europe, I met thousands of highly-intelligent, decent, hardworking men and women, from CEOs to laborers, almost all of whom I’m proud to call friend.</span></p>
<p class="ORIM-Body-Text-Indented--Body-"><span class="CharOverride-2">Several of my characters in my series of mysteries, both recurring and cameo characters, are based in part on real people I have known. Sheriff Bitters has the physical features and the good characteristics of Robert Reed, mechanical engineer. Lee Gallo is based on Leonard Vanell, chief chemist. George Simmons is a mix of several mining characters I’ve known, especially George Sites, maintenance supervisor, who did have lode fever and his own mine. Several geologists, including Chief Exploration Geologist Hugh Olmstead and my pal Robert Shank contributed to character Hugh Holcomb. I’ve previously mentioned that Al Victor has much of the personality of Harold Victor, journeyman instrument man and San Carlos Apache, and the physical appearance of Peter Curley, Arizona Highway Patrolman, retired, a Navajo. All of these good men, mentors, coworkers, and friends—except for Pete Curley and Robert Shank who are still hale and hearty—are now deceased, but I remember them all fondly.</span></p>
<p class="ORIM-Body-Text-Indented--Body-"><span class="CharOverride-2">Delvan Hayward, Miami Library, is retiring this year; she and Mrs. Cheves are accurately represented in this story. They and several other librarians and archivists who have inspired and assisted me through the decades are the objects of Manny Sanchez’s salute.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled434.vue?219a1ff6